import { useToast } from '@chakra-ui/react';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import FilterFormUI from '@Shared/components/form/FilterFormUI';
import { useMutation, useQuery } from '@tanstack/react-query';
import React, { ReactNode } from 'react';
import {
    getConsultingValidTransactionDataTableColumns,
    TButtonAction,
    TConsultingValidTransaction
} from './ConsultingValidTransactionDataTableMeta';
import consultingValidTransactionFormMeta from './ConsultingValidTransactionFilterFormData';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import CustomDrawer from '@Modules/core/components/CustomDrawer';

const initialColumnVisibility: {[x: string]: boolean} = {};

const ConsultingValidTransactionDataTableHandler = () => {

    const [rowDataTable, setRowDataTable] =
      React.useState<TConsultingValidTransaction>({
        primaryKey: '',
        date: '',
        tc: '',
        referenceNumber: '',
        trader: '',
        cardNumber: '',
        amount: '',
        currencyCode: '',

        currency: '',
        dba: '',
        total: '',
        account: '',
      });
  const detailsDrawerRef = React.useRef<any>(null);

  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ['ConsultingValidTransaction'];
  const { data, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve('data'), 500);
      });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const { isLoading: isSubmitting } = useMutation(async () => {}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
         await mutateAsync();
     } catch (error) {
         console.log(error);
     }*/
  };

  const handleBtn = (row: any, action: TButtonAction) => {
    switch (action) {
      case 'Transaction':
        // TODO: Handle click event on transaction dataTable button
        break;

      case 'Info':
        detailsDrawerRef?.current?.onOpen();
        break;

      default:
        break;
    }
  };

  const columns = getConsultingValidTransactionDataTableColumns({
    isLoading,
    handleBtn,
  });

  const drawerContent = React.useMemo(() => (<>
    <CC.SimpleGrid columns={3} spacing={5}>
    
      {columns.map((column, i) => {
        initialColumnVisibility[column.id!] = column.enableHiding === false ? false : true;

        return (column.enableHiding === false && column.id !== 'action' && column.header && <CC.Box key={i}>
          <CC.Heading size='xs' textTransform='uppercase'>
          {column.header as ReactNode}
          </CC.Heading>
          <CC.Text pt='2' fontSize='sm'>
          {rowDataTable[column.id!]}
          </CC.Text>
        </CC.Box>)
        })
      }
    </CC.SimpleGrid>
    <CC.Divider my={5} />
    
        
  </>),
  [columns, rowDataTable]);

  return (
    <>
      <FilterFormUI
        meta={consultingValidTransactionFormMeta}
        onSubmit={onSubmit}
        isLoading={isLoading}
        isSubmitting={isSubmitting}
      />

      <CustomReactTable
        data={data || [{}, {}, {}]}
        columns={columns}
        hasPagination={false} initialColumnVisibility={initialColumnVisibility}
      />

        <CustomDrawer title='Détails' ref={detailsDrawerRef}>
            {drawerContent}
        </CustomDrawer>
    </>
  );
};

export default ConsultingValidTransactionDataTableHandler;
